import {Color} from '~/constants/style';

export const expandedMonthlyRevenueBox = {
  gridColumn: '1 / span 2',
  gridRow: '1 / span 2',
  bgcolor: 'white',
  borderRadius: 3,
  p: 2,
  zIndex: 2,
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
  height: 500,
  minHeight: 480,
};
export const expandedMonthlyRevenueSkeletonStyles = {
  borderRadius: 3,
  minHeight: 340,
  height: '100%',
  width: '100%',
};

export const titleRow = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  mb: 2,
};

export const titleText = {
  fontSize: '18px',
  flex: 1,
  fontWeight: 700,
  color: Color.Purple600,
  textAlign: 'right',
  marginLeft: 1.5,
};

export const headerButtons = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
};

export const mainValueRow = {
  display: 'flex',
  width: '100%',
  gap: 2,
  ml: 1.5,
  alignItems: 'center',
  justifyContent: 'space-between',
};

export const revenueAmount = {
  fontSize: '48px',
  fontWeight: 700,
  color: Color.PrimaryMain,
};

export const monthTextBox = {
  display: 'flex',
  flexDirection: 'column',
  gap: 0.5,
};

export const selectMonth = {
  fontWeight: 700,
  color: Color.Purple600,
  minWidth: 100,
  '.MuiOutlinedInput-notchedOutline': {
    border: 0,
  },
  '.MuiSelect-icon': {
    color: Color.Purple600,
  },
};

export const selectMonthRow = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
};

export const statsBox = {
  display: 'flex',
  gap: 2,
  mt: 0,
  mb: 0,
  width: '100%',
};

export const chartBox = {
  width: '100%',
  height: 420,
};
export const leftSection = {
  display: 'flex',
  alignItems: 'center',
  gap: 0.5,
};

export const statCardBookingRate = {
  borderRadius: 2,
  p: 1,
  width: 160,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'flex-start',
  gap: 0.25,
  textAlign: 'center',
  border: `1px solid ${Color.Grey300}`,
};

export const statCardRevenueChange = {
  borderRadius: 2,
  p: 1.5,
  width: '18rem',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'flex-start',
  gap: 0.5,
  border: `1px solid ${Color.Grey300}`,
};

export const estimatedRevenueTextStyle = {
  fontWeight: 400,
  color: Color.Grey500,
  fontSize: '14px',
};
export const percentageText = {
  fontSize: '24px',
  fontWeight: 600,
  color: Color.ErrorMain,
};

export const bookingRateLabel = {
  fontSize: '14px',
  fontWeight: 400,
  color: Color.Grey500,
};
export const bookingRatePercentageTextStyle = {
  fontSize: '24px',
  fontWeight: 600,
  color: Color.PrimaryMain,
};

export const paymentTextStyles = {
  mb: 1,
  ml: 1.5,
  fontWeight: 400,
  color: Color.TextPrimary,
  fontSize: '16px',
  lineHeight: '18px',
};

export const statsAndArrowsRow = {
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  mb: 0,
  ml: 2,
  justifyContent: 'space-between',
};

export const arrowNavContainer = {
  display: 'flex',
  alignItems: 'center',
  ml: 2,
  mt: 2,
  gap: 1,
  mr: 3,
};

export const arrowButtonBox = {
  bgcolor: '#F5F6F7',
  borderRadius: 2,
  p: 0.5,
};

export const tooltipBox = {
  bgcolor: Color.White,
  borderRadius: 2,
  p: 2,
  boxShadow: 2,
  minWidth: 180,
};

export const tooltipMonth = {
  color: Color.Purple600,
  fontWeight: 700,
  mb: 1,
};

export const tooltipLabel = {
  color: Color.TextPrimary,
  fontWeight: 400,
};

export const tooltipValue = {
  color: Color.Primary2Darkest,
  fontWeight: 700,
  fontSize: 20,
  mb: 1,
};

export const xAxisTickStyle = {
  fontFamily: 'Inter',
  fontSize: 14,
  fontWeight: 600,
  letterSpacing: '-0.105px',
  fontStyle: 'semibold',
  fill: Color.TextPrimary,
  textAnchor: 'middle',
};

export const yAxisTickStyle = {
  fontFamily: 'Inter',
  fontSize: 14,
  fontWeight: 400,
  letterSpacing: '-0.105px',
  fill: Color.TextPrimary,
  textAnchor: 'end',
};

export const monthSelectorContainer = {
  flexShrink: 0,
  marginRight: 15,
  minWidth: 200,
};

export const downloadButton = {
  '&:hover': {
    backgroundColor: Color.Grey200,
  },
};

export const downloadButtonDisabled = {
  '&:hover': {
    backgroundColor: 'transparent',
  },
};

export const circularProgress = {
  color: Color.PrimaryMain,
};
